<!--<template>
  <div class="main_div">
    <iframe :src="iframeSrc" style="height: 100%;width: 100%;"/>
  </div>
</template>-->

<template>
  <div class="main_div">
<!--    <el-button size="small" @click="addTab(editableTabsValue)">
      add tab
    </el-button>-->
    <el-tabs
        v-model="editableTabsValue"
        type="card"
        class="demo-tabs"
        style="width: 100% ; height: 100%"
        closable
        @tab-remove="removeTab"
    >
      <el-tab-pane
          v-for="item in editableTabs"
          style="width: 100% ; height: 100%"
          :key="item.name"
          :label="item.title"
          :name="item.name"
      >
        <div>
          <iframe
              :src="item.url"
              :id="`${item.id}iframe`"
              :onload="
                  `const oIframe = document.getElementById('${item.id}iframe');
                  const deviceHeight = document.documentElement.clientHeight - 50 - 42;
                  oIframe.style.height = Number(deviceHeight)+'px';
                  window.onresize = () => {
                      console.info(1111)
                      const deviceHeight = document.documentElement.clientHeight - 50 - 42;
                      oIframe.style.height = Number(deviceHeight)+'px';
                  };
                  `"
              style='overflow-x:auto;overflow-y:hidden;width: 100% ;'
          ></iframe>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { siderStore } from '@/stores/siderStore'
//实现仓库数据双向绑定
import {storeToRefs} from 'pinia';
import {ref, toRaw} from "vue";
import bus from '@/components/mittBus/mitt';


export default {
  name: "MainComponent",
  setup() {
    const side_Store =siderStore();
    // 当前选中tab下表
    let tabIndex = 1;
    let{tabUrl} = storeToRefs(side_Store);
    const editableTabsValue = ref('1')
    const editableTabs = ref([
      {
        title: '首页',
        name: '1',
        content: 'Tab 1 content',
        url: '/dashboard',
        id: 1
      }
    ])
    // 跳转 首页
    function addTab(data){
      tabIndex = data.permissionId.toString()
      const newTabIndex = tabIndex

      let exsit = editableTabs.value.find(item => item.id === data.permissionId)
      if(!exsit){
        editableTabs.value.push({
          title: data.permissionName,
          name: newTabIndex,
          content: "{{data.permissionName}}",
          url: data.permission,
          id: data.permissionId
        })
      }
      editableTabsValue.value = newTabIndex
    }

    function removeTab(targetName){
      const tabs = editableTabs.value
      let activeName = editableTabsValue.value
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }

      editableTabsValue.value = activeName
      editableTabs.value = tabs.filter((tab) => tab.name !== targetName)
    }

    return {
      iframeSrc:"#/about",
      editableTabsValue,
      editableTabs,
      addTab,
      removeTab
    }
  },
  mounted() {
    bus.on('siderToMain',data=>{
      this.addTab(data)
    })
  }
}
</script>

<style scoped>
.main_div{
  width: 100%;
  #height: 100%;
  overflow: auto;
}

:deep(.el-tabs__header) {
  margin: 0;
}
</style>